// extracted by mini-css-extract-plugin
export default {"wrapper":"NodeList_wrapper__mywD7"};